import { React, useState, useEffect, useCallback } from "react";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import OutsideClickHandler from "react-outside-click-handler";

import DropDownMenu from "../../../commonComponents/DropDownMenu";
import { LinkButton, Button } from "../../../commonComponents/Buttons";
import VideoViewer from "../../../commonComponents/VideoViewer/VideoViewer";

import { useWindowDimensions } from "../../../../hooks";

import challengesService from "../../../../services/challengesService";

import { LikedIcon, UnlikedIcon } from "../../../../assets";
import "./multipleVideoView.scss";

function MultipleVideoView() {
  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  const params = useParams();
  const [count, setCount] = useState();
  const [kidChallenges, setKidChallenges] = useState([]);
  const [isActiveVideo, setIsactiveVideo] = useState();
  const [dropDownNav, setDropDownNav] = useState();

  const activeVideoItem = useCallback(
    (item) => {
      setIsactiveVideo(item?.id);
      setCount({
        url: item?.content,
        title: item?.title,
        likes: item?.likes,
        liked: item?.liked,
        itemId: item?.id,
        categoryId: params.categoryId,
        challengeId: params.challengeId,
      });
    },
    [params.categoryId, params.challengeId]
  );

  useEffect(() => {
    if (!kidChallenges.length) {
      challengesService
        .getOwnerChallenges(
          params.categoryId,
          params.challengeId,
          params.userId
        )
        .then((response) => {
          setKidChallenges(response.data);
          activeVideoItem(response.data[0]);
        });
    }
  }, [kidChallenges, params, activeVideoItem]);

  function likeHandler(kidChallengeId) {
    challengesService
      .addKidsChallengeLike(
        params.categoryId,
        params.challengeId,
        kidChallengeId
      )
      .then((result) => {
        let tempArray = [...kidChallenges];
        const index = kidChallenges.findIndex(
          (item) => item?.id === kidChallengeId
        );
        tempArray[index] = {
          ...tempArray[index],
          liked: result?.data?.result?.liked,
          likes: result?.data?.result?.likes,
        };
        setKidChallenges(tempArray);
        setCount({
          ...count,
          likes: result?.data?.result?.likes,
          liked: result?.data?.result?.liked,
        });
      });
  }

  return (
    <main>
      <LinkButton
        label={t("back")}
        iconClassName="hasIcon--chevron-left"
        viewType="backButton"
        goTo={`/challenge/${params.categoryId}/list/${params.challengeId}`}
      />
      {width <= 1025 && (
        <OutsideClickHandler onOutsideClick={() => setDropDownNav(false)}>
          <section
            onClick={() => setDropDownNav(!dropDownNav)}
            className="asideDropDown"
            title="Video"
            id="asideDropDown"
          >
            <p className="activeItemTxt hasIcon--chevron-down">
              {count?.title}
            </p>
            {dropDownNav && (
              <DropDownMenu>
                <ul>
                  {kidChallenges.map((item) => (
                    <li key={item?.id}>
                      <button
                        className={
                          isActiveVideo === item.id ? "currentItem" : ""
                        }
                        onClick={() => activeVideoItem(item)}
                      >
                        {item?.title}
                      </button>
                    </li>
                  ))}
                </ul>
              </DropDownMenu>
            )}
          </section>
        </OutsideClickHandler>
      )}
      <section className="withAsideButtons">
        {width > 1025 && (
          <aside>
            <p className="asideTitle">
              {kidChallenges[0]?.user?.name}
              {kidChallenges[0]?.user?.age &&
                `, ${kidChallenges[0]?.user?.age} years`}
            </p>
            <ul className="navList">
              {kidChallenges.map((item) => (
                <li key={item?.id}>
                  <button
                    className={isActiveVideo === item.id ? "currentItem" : ""}
                    onClick={() => activeVideoItem(item)}
                  >
                    {item?.title}
                  </button>
                </li>
              ))}
            </ul>
          </aside>
        )}

        <section className="videoContent">
          <div className="videoContentHeader">
            <h2>{count?.title}</h2>
            <div className="activityCounter">
              <Button
                viewType="clildrenBtn"
                onClick={() => likeHandler(count?.itemId)}
              >
                <img
                  className="activityIcon"
                  src={count?.liked ? LikedIcon : UnlikedIcon}
                  alt={t("likes")}
                />
              </Button>
              <p className="activityTxt">{count?.likes}</p>
            </div>
          </div>

          <VideoViewer
            handlers="challengesAnswerView"
            videoUrl={count?.url}
            videoId={count?.itemId}
            userId={params.userId}
            videoTitle={count?.title}
            categoryId={count?.categoryId}
            challengeId={count?.challengeId}
          />
        </section>
      </section>
    </main>
  );
}

export default MultipleVideoView;
